import axios from "axios";

export const phonePrefixes = [
  { code: "GT", name: "Guatemala", prefix: "+502", flag: "🇬🇹" },
  { code: "BZ", name: "Belice", prefix: "+501", flag: "🇧🇿" },
  { code: "HN", name: "Honduras", prefix: "+504", flag: "🇭🇳" },
  { code: "SV", name: "El Salvador", prefix: "+503", flag: "🇸🇻" },
  { code: "NI", name: "Nicaragua", prefix: "+505", flag: "🇳🇮" },
  { code: "CR", name: "Costa Rica", prefix: "+506", flag: "🇨🇷" },
  { code: "PA", name: "Panamá", prefix: "+507", flag: "🇵🇦" },
  { code: "DO", name: "República Dominicana", prefix: "+1", flag: "🇩🇴" },
  { code: "MX", name: "México", prefix: "+52", flag: "🇲🇽" }
];

export const getUserCountry = async () => {
  try {
    const response = await axios.get("https://api.country.is/");
    const userCountry = response.data.country;
    return phonePrefixes.find((c) => c.code === userCountry) || phonePrefixes[0];
  } catch (error) {
    console.error("Error al obtener el país del usuario:", error);
    return phonePrefixes[0]; // Retorna Guatemala por defecto en caso de error
  }
};